export default [
	{ title: 'An Expecting Parent', value: 'expecting-a-baby' },
	{ title: 'A New Parent', value: 'new-parent' },
	{ title: 'Part of a Growing Family', value: 'growing-family' },
	{ title: 'A Health Professional', value: 'health-professional' },
]